<h2 mat-dialog-title>{{ data.notification ? 'Editar notificación' : 'Añadir notificación' }}</h2>

<mat-dialog-content [formGroup]="notificationForm">
  <mat-form-field appearance="outline" style="width: 100%; margin-bottom: 16px">
    <mat-label>Notificación</mat-label>
    <mat-select formControlName="channels" multiple>
      <mat-option value="email">Correo electrónico</mat-option>
      <mat-option value="slack">Slack</mat-option>
      <mat-option value="calendar_app">Notificación</mat-option>
    </mat-select>
    @if (notificationForm.controls['channels'].invalid && notificationForm.controls['channels'].touched) {
      <mat-error>Selecciona al menos un canal</mat-error>
    }
  </mat-form-field>

  <mat-form-field appearance="outline" style="width: 100%; margin-bottom: 16px">
    <mat-label>Minutos antes</mat-label>
    <input matInput type="number" formControlName="minutes_before" min="0" />
    <mat-hint>0 = en el momento del evento</mat-hint>
    @if (notificationForm.controls['minutes_before'].invalid && notificationForm.controls['minutes_before'].touched) {
      <mat-error>Debe ser un número mayor o igual a 0</mat-error>
    }
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Cancelar</button>
  <button mat-flat-button color="accent" (click)="save()" [disabled]="notificationForm.invalid">Guardar</button>
</mat-dialog-actions>
